export default {
  name: "workType",
  type: "document",
  title: "Type",
  fields: [
    {
      name: "title",
      type: "string",
      title: "Title",
      validation: Rule => Rule.required(),
    },
    {
      name: "order",
      type: "number",
      title: "Order",
    },
  ],
  preview: {
    select: {
      title: 'title',
      subtitle: 'order'
    }
  },
  orderings: [
    {
      title: 'Number',
      name: 'numberAsc',
      by: [
        { field: 'order', direction: 'asc' }
      ]
    },
  ]
};



// WEBPACK FOOTER //
// ./schemas/workType.js